export class ProtocoloAgrupamentoPost {
  
  id: number;

  constructor(id: number){
      this.id=id;
  }

}